import { PlanTypesEnum } from '@ctct/domain-layer';
import type { ComparisonTableFeature, ComparisonTableGroup } from '@ctct/payflow-ui';

import content from './content';
import marketingData from './marketingData';
import type { ContentStrategy } from '../ContentStrategy';

const idToTypeMap = {
  '1': PlanTypesEnum.Bronze,
  '2': PlanTypesEnum.Silver,
  '3': PlanTypesEnum.Gold,
};

/**
 * Content strategy for the plan-restructure experiment cohort (planGroupId 385 / 386).
 *
 * Renders the repackaged pricing copy: Lite unlocks scheduled sends / A/B testing /
 * personalization / dynamic content / resend-to-non-openers / unlimited automation
 * templates / custom paths, gains segmentation caps (2 segments / 10 lists),
 * loses total-integrations cap (3), and the monthly send multiplier drops from
 * 10x to 5x. Standard loses the segmentation cap (5 segments / 25 lists) and
 * gains dynamic content. Enterprise integrations (Salesforce, MS Dynamics)
 * become Premium-only. Pricing is unchanged from the default strategy — billing-svc
 * drives pricing per contact tier once BIA finishes populating entitlements.
 *
 * See CPD-25373 and the source-of-truth sheet:
 * https://docs.google.com/spreadsheets/d/1E1maAuM9IrIs6S0mQrpXZC9CkgLk0JKDp1RHJZZNWGg
 */
export class PlanRestructureContentStrategy implements ContentStrategy {
  getInitialGroups(): ComparisonTableGroup[] {
    return content.groups.map((g) => ({
      ...g,
      features: g.features.map((f) => ({
        ...f,
        parameters: f.parameters.map((p) => ({ ...p, id: idToTypeMap[p.id] })),
      })),
    }));
  }

  getInitialPlans() {
    return content.headers.plans;
  }

  getStaticTableContent(): ComparisonTableFeature[] {
    return marketingData.features.slice(1).map((f) => ({
      ...f,
      parameters: f.parameters.map((p) => ({ ...p, id: idToTypeMap[p.id] })),
    }));
  }
}
